export enum ShiftAssignmentMode {
  Assigned = 'assigned',
  Unassigned = 'unassigned',
  All = 'all',
}
